import React, { useContext } from "react";
import { UploadDataType } from "@data-types/sow/PlayerSowTypes";
import { useTranslation } from "react-i18next";
import {
	PlayerSowInfo,
	SowDocumentUploadSection,
	SowFilesSection,
	SowQuestionFields,
} from ".";
import { FormButton } from "@components/buttons";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";

import { useForm, FormProvider, FieldValues } from "react-hook-form";

import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";
import { CheckboxField } from "@components/inputs/desktop";

export const SowSubmissionForm = observer(function SowSubmissionForm() {
	const { t } = useTranslation();

	const playerSowStore = useContext(PlayerSowStoreContext);

	const methods = useForm({
		mode: "onChange",
		defaultValues: {
			userName: playerSowStore?.rootStore.userAuthStore.user?.username,
		},
	});

	const { search } = useLocation();
	const queryParams = new URLSearchParams(search);

	const params: Record<string, string> = {};

	queryParams.forEach((value, key) => {
		params[key] = value;
	});

	if (!playerSowStore) {
		return null;
	}

	const handleSubmitForm = async (data: FieldValues) => {
		const submitParams: UploadDataType = {
			requestId: params.requestId,
			userId: params.userId,
		};

		await playerSowStore.onSubmitFullForm(data, submitParams);
	};

	return (
		<FormProvider {...methods}>
			<form
				encType="multipart/form-data"
				onSubmit={methods.handleSubmit(
					async (data) => await handleSubmitForm(data)
				)}
			>
				<div className="card--primary">
					<div className="card--primary__header">
						<div className="card--primary__title title--primary">
							{t("PLAYER_SOW.TITLE")}
						</div>
					</div>
					<div className="card--primary__body">
						<PlayerSowInfo
							isFullForm={playerSowStore.isFormRequired}
						/>
						<SowQuestionFields />
						<SowDocumentUploadSection />
						<SowFilesSection />
						<div className="u-type--base u-mar--top--xsml">
							<label
								htmlFor="sowTextarea"
								className="label u-type--wgt--medium"
							>
								{t("PLAYER_SOW.TEXTAREA_PLACEHOLDER")}
							</label>
							<textarea
								id="sowTextarea"
								maxLength={10000}
								className="input input--med input--textarea"
								onChange={(e) =>
									playerSowStore.setNotes(e.target.value)
								}
							></textarea>
						</div>
					</div>
					<div className="card--primary__footer">
						<CheckboxField
							name="confirmCheckbox"
							id="sowConfirmCheckbox"
							required={playerSowStore.isFormRequired}
							label={t("PLAYER_SOW.CHECKBOX_TEXT")}
							checkboxClassname="input--check u-mar--bottom--xsml"
						/>
						<FormButton
							className="btn--base btn--accent card--primary__footer__btn"
							type="submit"
							btnText={t("PLAYER_SOW.SUBMIT_BUTTON")}
							disabled={playerSowStore.files.length == 0}
						/>
					</div>
					<div className="card--primary__footer u-mar--top--sml">
						<span className="label">
							{t("PLAYER_SOW.DATA_COLLECTION")}
						</span>
					</div>
				</div>
			</form>
		</FormProvider>
	);
});
